import { gql } from '@apollo/client';

export const SERVICES_FIELDS = gql`
    fragment ServicesFields on services {
        service_id
        code
        type
        description
        quantity
        size
        require_confirm
        billable
        service_time
        metadata
    }
`;

export const SERVICE_CATALOG_FIELDS = gql`
    fragment ServiceCatalogFields on service_catalog {
        service_id
        service_code
        description
        service_type
        size
        require_confirm
        billable
        service_time
        dimensions
        dimension_key
    }
`;
